import React from 'react';

import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {Clear} from "../../../../../core/icons/clear";
import {ACTION_TYPES} from "../../../../../core/consts";
import styles from "../styles/game-center-header.module.scss"
import classNames from "classnames";

export class GameCenterHeaderClearButtonProps extends BaseProps {
  device: DeviceViewModel;
  isWidget: Boolean;
}

export const GameCenterHeaderClearButton = ({controller}: GameCenterHeaderClearButtonProps) => {
  const {state} = controller;

  const clearProps = {
    className: classNames(styles.clear),
    onClick: () => controller.action(ACTION_TYPES.onGameContextClose)
  }

  return state.shouldRenderClearButton ? <Clear {...clearProps}/> : null
};
